import { PropertyAPI } from "../../axios";

export const actions = {

    // Disposal
    GetPropertyDisposal(context, data){
        return PropertyAPI.get(`Disposal/Campus/${data}`);
    },
    GetDraftPropertyDisposal(context, data){
        return PropertyAPI.get(`Disposal/Draft/Campus/${data}`);
    },
    GetPostedPropertyDisposal(context, data){
        return PropertyAPI.get(`Disposal/Posted/Campus/${data}`);
    },
    GetPropertyDisposalSingle(context, data){
        return PropertyAPI.get(`Disposal/${data}`);
    },
    CreatePropertyDisposal(context, data){
        return PropertyAPI.post(`Disposal/Create`, data);
    },
    CreatePropertyDisposalWithItems(context, data){
        return PropertyAPI.post(`Disposal/Create/WithItems`, data);
    },
    PostPropertyDisposal(context, data){
        return PropertyAPI.post(`Disposal/${data}`);
    },
    UpdatePropertyDisposal(context, data){
        return PropertyAPI.put(`Disposal/${data.id}`, data);
    },
    DeletePropertyDisposal(context, data){
        return PropertyAPI.delete(`Disposal/${data}`);
    },

    //Disposal Items
    GetPropertyDisposalItem(context, data){
        return PropertyAPI.get(`DisposalItem/Disposal/${data.id}/${data.isPosted}`);
    },
    GetPropertyDisposalItemSingle(context, data){
        return PropertyAPI.get(`DisposalItem/${data}`);
    },
    AddPropertyDisposalItem(context, data){
        return PropertyAPI.post(`DisposalItem/Add`, data);
    },
    UpdatePropertyDisposalItem(context, data){
        return PropertyAPI.put(`DisposalItem/${data.id}`, data);
    },
    DeletePropertyDisposalItem(context, data){
        return PropertyAPI.delete(`DisposalItem/${data}`);
    },
    PostMultiplePropertyDisposalItem(context, data){
        return PropertyAPI.post(`DisposalItem/Post`, data);
    },
    UnpostMultiplePropertyDisposalItem(context, data){
        return PropertyAPI.post(`DisposalItem/UnPost`, data);
    },

}